import ListProduct from './ListProduct.jsx';

export {
  ListProduct
}


// WEBPACK FOOTER //
// ./components/product-detail/sub-view/list-product/index.js